<template>
  <tr class="chart-row">
    <slot></slot>
  </tr>
</template>

<script>
export default {
  name: "ChartRow",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.chart-row {
  width: 100%;
}
</style>
